var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { singleton } from "tsyringe";
import { makeImmutable } from "../core";
import { LocalizationProvider } from "../locale";
import { P24_CHANNEL_ID } from "../ordering";
import { DialogStateManager, POrderSummary, } from "../presentation";
import { CheckoutService, OrderSummaryService } from "../services";
import { StorageManagerFactory } from "../storage";
import { LastCheckoutRequestStorageManager } from "../storageBase";
let POrderSummaryFactory = class POrderSummaryFactory {
    constructor(orderSummaryService, storageManagerFactory, localizationProvider, dialogStateManager, checkoutService) {
        this.orderSummaryService = orderSummaryService;
        this.storageManagerFactory = storageManagerFactory;
        this.localizationProvider = localizationProvider;
        this.dialogStateManager = dialogStateManager;
        this.checkoutService = checkoutService;
        makeImmutable(this);
    }
    create(params) {
        const fulfillmentTimeStorageManager = this.storageManagerFactory.forFulfillmentTime();
        const cartStorageManager = this.storageManagerFactory.forCart(params.restaurantSlug);
        const previousCartStorageManager = this.storageManagerFactory.forPreviousCart(params.restaurantSlug);
        const orderItemListStorageManager = this.storageManagerFactory.forOrderItemList();
        const performPaymentRetry = params.placeOrderCallback
            ? async () => {
                var _a;
                let request = LastCheckoutRequestStorageManager.restore();
                if (request === null)
                    return null;
                // If the original payment was BLIK Level 0, retry with standard BLIK
                if (((_a = request.payment) === null || _a === void 0 ? void 0 : _a.channel.tag) === "P24Channel" &&
                    request.payment.channel.contents === P24_CHANNEL_ID.BLIK_LEVEL_0) {
                    request = {
                        ...request,
                        payment: {
                            ...request.payment,
                            channel: { tag: "P24Channel", contents: P24_CHANNEL_ID.BLIK },
                            blikCode: null,
                        },
                    };
                }
                return await this.checkoutService.checkout(request);
            }
            : null;
        return new POrderSummary({
            orderSummaryService: this.orderSummaryService,
            orderUuid: params.orderUuid,
            localizationProvider: this.localizationProvider,
            cartStorageManager,
            previousCartStorageManager,
            orderItemListStorageManager,
            fulfillmentTimeStorageManager,
            dialogStateManager: this.dialogStateManager,
            redirectToRetryOrder: params.redirectToRetryOrder,
            performPaymentRetry,
            onPaymentRetrySuccess: params.placeOrderCallback,
        });
    }
};
POrderSummaryFactory = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof OrderSummaryService !== "undefined" && OrderSummaryService) === "function" ? _a : Object, typeof (_b = typeof StorageManagerFactory !== "undefined" && StorageManagerFactory) === "function" ? _b : Object, typeof (_c = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _c : Object, typeof (_d = typeof DialogStateManager !== "undefined" && DialogStateManager) === "function" ? _d : Object, typeof (_e = typeof CheckoutService !== "undefined" && CheckoutService) === "function" ? _e : Object])
], POrderSummaryFactory);
export { POrderSummaryFactory };
